module.exports = __webpack_public_path__ + "img/m3.7422ad5d.png";